/*
  Fit guide dialog (snippets/slvr-size-guide.liquid).
  Any element with data-slvr-size-guide-open opens it: the Size & fit block's link and the
  accordion's Size & fit item. aria-controls picks a specific dialog; otherwise the first one on the page.
*/
(function () {
  if (window.slvrSizeGuideReady) return;
  window.slvrSizeGuideReady = true;

  var CLOSE_MS = 320;
  var lastTrigger = null;

  function findDialog(trigger) {
    var id = trigger && trigger.getAttribute('aria-controls');
    return (id && document.getElementById(id)) || document.querySelector('dialog.slvr-size-guide');
  }

  function open(dialog, trigger) {
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    lastTrigger = trigger || null;
    dialog.showModal();
    document.documentElement.classList.add('slvr-size-guide-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { dialog.classList.add('is-open'); });
    });
  }

  function close(dialog) {
    if (!dialog || !dialog.open || dialog.dataset.closing) return;
    dialog.dataset.closing = 'true';
    dialog.classList.remove('is-open');
    setTimeout(function () {
      delete dialog.dataset.closing;
      dialog.close();
      document.documentElement.classList.remove('slvr-size-guide-lock');
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    }, CLOSE_MS);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-slvr-size-guide-open]');
    if (opener) {
      event.preventDefault();
      open(findDialog(opener), opener);
      return;
    }
    var dialog = event.target.closest('dialog.slvr-size-guide');
    if (!dialog) return;
    // A click on the dialog itself (not its panel) is a click on the backdrop
    if (event.target === dialog || event.target.closest('[data-slvr-size-guide-close]')) close(dialog);
  });

  // Esc: animate out instead of the browser's instant close
  document.addEventListener('cancel', function (event) {
    if (event.target.matches && event.target.matches('dialog.slvr-size-guide')) {
      event.preventDefault();
      close(event.target);
    }
  }, true);

  // Theme editor: show the guide while its block is selected, so its text can be edited
  document.addEventListener('shopify:block:select', function (event) {
    var dialog = event.target.querySelector && event.target.querySelector('dialog.slvr-size-guide');
    if (dialog) open(dialog, null);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var dialog = event.target.querySelector && event.target.querySelector('dialog.slvr-size-guide');
    if (dialog) close(dialog);
  });
})();
